// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"d91d2cd8","845":"659265a7"}[chunkId] + ".chunk.js";
};